<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m5.6 12 1.9-3.6v-.9H4.7v.9h1.8L4.7 12m4.6 0L11 8.4v-.9H8.4v.9h1.8L8.4 12m4.5 0 1.8-3.6v-.9H12v.9h1.8L12 12m8.2-9q-1.6.1-1.8 1.8 0 1 .9 1.5v10.2h-2.8v-1.8q1 0 1-.9V5.7q0-.8-1-.9h-3.4Q11.9 3.1 9.7 3 7.6 3 6.4 4.8H2.9q-.8 0-.9.9v8.1q0 .8 1 .9V21h13.5v-2.7h2.8q1.7-.1 1.8-1.8V6.3q.8-.5.9-1.5-.2-1.7-1.8-1.8m-7.3 15.3H6.5v-1.8H13zm2.7-5.4H3.8V6.6h11.8z"
    />
  </svg>
</template>
